<template>
  <div
    class="registration-error border-EXPONDO-red w-full p-6 bg-EXPONDO-red-light text-EXPONDO-red"
  >
    {{ $t(errorMessage) }}
  </div>
</template>

<script lang="ts">

import { errorToString } from '~~/helpers/error/errorToString';

export default defineComponent({
  name: 'GenericFormError',
  props: {
    error: {
      type: [String, Error],
      default: '',
    },
  },
  setup(props) {

    return {
      errorMessage: computed<string>(() => {

        if (!props.error) {

          return 'Something went wrong on our side. Please try again or contact support';
        
        }

        return errorToString(props.error);
      
      }),
    };
  
  },
});

</script>

<style lang="scss" scoped>

.registration-error {
  border-radius: var(--form-border-radius);
}
</style>
